import React from 'react';
import { useTranslation } from 'react-i18next';
import Header from './Header';
import Footer from './Footer';
import CookieConsentBanner from './CookieConsentBanner';
import CookiePreferencesLink from './CookiePreferencesLink';

const Layout = ({ children }) => {
  const { t } = useTranslation();

  return (
    <div className="app-container">
      <a className="skip-link" href="#main-content">
        {t('a11y.skip_to_content', 'Skip to main content')}
      </a>
      <Header />
      <main id="main-content" className="main-content" tabIndex={-1}>
        {children}
      </main>
      <Footer />
      <CookiePreferencesLink />
      <CookieConsentBanner />
    </div>
  );
};

export default Layout;
